export const MenuList = [
	{
		title: "Dashboard",
		icon: "dashboard",
		iconType: "outlined",
		to: "dashboard",
	},
	{
		title: "KYC Master",
		classsChange: "mm-collapse",
		icon: "verified_user",
		iconType: "filled",
		content: [
			{
				title: "Add KYC",
				to: "/kyc-master/add",
			},
			{
				title: "Manage KYC",
				to: "/kyc-master",
			},
		],
	},
	{
		title: "Companies",
		classsChange: "mm-collapse",
		icon: "business",
		iconType: "filled",
		content: [
			{
				title: "Add Company",
				to: "/companies/add",
			},
			{
				title: "Manage Company",
				to: "/companies",
			},
		],
	},
	{
		title: "Company Balance",
		classsChange: "mm-collapse",
		icon: "account_balance_wallet",
		iconType: "filled",
		content: [
			{
				title: "Company Balances",
				to: "/company-balance",
			},
			{
				title: "Balance Logs",
				to: "/company-balance-logs",
			},
		],
	},
	{
		title: "Company KYC",
		classsChange: "mm-collapse",
		icon: "business_center",
		iconType: "filled",
		content: [
			{
				title: "Add Company KYC",
				to: "/company-kyc/add",
			},
			{
				title: "Manage Company KYC",
				to: "/company-kyc",
			},
		],
	},
	{
		title: "Branches",
		classsChange: "mm-collapse",
		icon: "account_tree",
		iconType: "filled",
		content: [
			{
				title: "Add Branch",
				to: "/branches/add",
			},
			{
				title: "Manage Branches",
				to: "/branches",
			},
		],
	},
	{
		title: "User Management",
		classsChange: "mm-collapse",
		icon: "people",
		iconType: "filled",
		content: [
			{
				title: "Add User",
				to: "/users/create",
			},
			{
				title: "Manage User",
				to: "/users",
			},
		],
	},
    {
		title: "Menu Configuration",
		classsChange: "mm-collapse",
		icon: "people",
		iconType: "filled",
		content: [
			{
				title: "Add Menu Configuration",
				to: "/menu-config/create",
			},
			{
				title: "Manage Menu Configuration",
				to: "/menu-config",
			},
		],
	},
	{
		title: "Depositors",
		classsChange: "mm-collapse",
		icon: "account_circle",
		iconType: "filled",
		content: [
			{
				title: "Add Depositors",
				to: "/depositors/create",
			},
			{
				title: "Manage Depositors",
				to: "/depositors",
			},
		],
	},

	{
		title: "Deposits",
		classsChange: "mm-collapse",
		icon: "savings",
		iconType: "filled",
		content: [
			{
				title: "Add Deposits",
				to: "/deposits/add",
			},
			{
				title: "Manage Deposits",
				to: "/deposits",
			},
		],
	},
	{
		title: "Deposit Interest",
		classsChange: "mm-collapse",
		icon: "monetization_on",
		iconType: "filled",
		content: [
			{
				title: "Add Interest Payment",
				to: "/deposit-interest/add",
			},
			{
				title: "Manage Interest Payments",
				to: "/deposit-interest",
			},
		],
	},
	{
		title: "Customers",
		classsChange: "mm-collapse",
		icon: "people_alt",
		iconType: "filled",
		content: [
			{
				title: "Add Customer",
				to: "/customers/add",
			},
			{
				title: "Manage Customers",
				to: "/customers",
			},
		],
	},
	{
		title: "Loans",
		classsChange: "mm-collapse",
		icon: "account_balance",
		iconType: "filled",
		content: [
			{
				title: "Add Loan",
				to: "/loans/add",
			},
			{
				title: "Manage Loans",
				to: "/loans",
			},
		],
	},
	{
		title: "Loan Payments",
		classsChange: "mm-collapse",
		icon: "payments",
		iconType: "filled",
		content: [
			{
				title: "Add Loan Payment",
				to: "/loans-payments/add",
			},
			{
				title: "Manage Loan Payments",
				to: "/loans-payments",
			},
		],
	},
	{
		title: "Reports",
		classsChange: "mm-collapse",
		icon: "bar_chart",
		iconType: "filled",
		content: [
			{
				title: "View Reports",
				to: "/reports",
			},
		],
	},
];
